import { render, staticRenderFns } from "./indexPageExample.vue?vue&type=template&id=20631d26&scoped=true&"
import script from "./indexPageExample.vue?vue&type=script&lang=js&"
export * from "./indexPageExample.vue?vue&type=script&lang=js&"
import style0 from "./indexPageExample.vue?vue&type=style&index=0&id=20631d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20631d26",
  null
  
)

export default component.exports